import { HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

import Button from '@/components/base/Button'
import Typography from '@/components/base/Typography'
import { useLenis } from '@/contexts/lenis'
import { useLoaderStore } from '@/store/loader'

import { cn } from '@/lib/utils'

export type HeroButtonProps = HTMLAttributes<HTMLElement>

const MAILTO_HREF = `mailto:atelier@henge07.com`

const HeroButton = ({ className, ...props }: HeroButtonProps) => {
  const wrapper = useRef<HTMLDivElement>(null!)
  const loaded = useLoaderStore((state) => state.pageLoaded)
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis || !loaded) return
      const hero = document.querySelector('[data-hero]')

      gsap.set(wrapper.current, {
        x: '50%',
        right: '50%'
      })

      const triggerHero = ScrollTrigger.create({
        trigger: hero,
        start: 'bottom 80%',
        onEnter: () => {
          gsap.to(wrapper.current, {
            overwrite: true,
            x: '0%',
            right: 20,
            duration: 1,
            ease: 'power2.out'
          })
        },
        onLeaveBack: () => {
          gsap.to(wrapper.current, {
            overwrite: true,
            x: '50%',
            right: '50%',
            duration: 1,
            ease: 'power2.out'
          })
        }
      })

      return () => {
        if (triggerHero) triggerHero.kill()
      }
    },
    {
      dependencies: [lenis, loaded],
      scope: wrapper,
      revertOnUpdate: true
    }
  )

  return (
    <div
      ref={wrapper}
      data-hero-button
      {...props}
      className={cn('mix-blend-exclusion', className)}
    >
      <Button type="button" variant="dark" asChild>
        <a href={MAILTO_HREF} data-label="Access Press Kit">
          <Typography variant="button" className="text-center">
            {'REQUEST INFO'}
          </Typography>
        </a>
      </Button>
    </div>
  )
}

export default HeroButton
